import Icon from 'veui/components/Icon'
import { IconBulb } from 'dls-icons-vue'

Icon.register('bulb', IconBulb)
